import { render, staticRenderFns } from "./SideBarItem.vue?vue&type=template&id=da2fcf00&scoped=true&"
import script from "./SideBarItem.vue?vue&type=script&lang=js&"
export * from "./SideBarItem.vue?vue&type=script&lang=js&"
import style0 from "./SideBarItem.vue?vue&type=style&index=0&id=da2fcf00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2fcf00",
  null
  
)

export default component.exports